import { render, staticRenderFns } from "./Households.vue?vue&type=template&id=80bfe41a&scoped=true&"
import script from "./Households.vue?vue&type=script&lang=js&"
export * from "./Households.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bfe41a",
  null
  
)

export default component.exports